<template>
  <main class="wrapper">
    <the-filter v-model="filter"></the-filter>
    <section class="questions">
      <div class="question" v-for="item in filteredQuestions" :key="item[0]" v-if="!(filteredQuestions.value === [])">
        <h1>{{item[0]}}</h1>
        <p>Ответ: {{item[1]}}</p>
      </div>
    </section>
  </main>
</template>

<script>
  import TheFilter from "@/components/TheFilter";
  import {ref, computed} from "vue";

  export default {
    components: {TheFilter},

    setup() {

      const filter = ref({})

      const questions = ref([
        ['Зачем нужен договор на ТО?', 'Договор на ТО ВДГО является обязательным условием для заключения Договора на поставку газа'],
        ['Кто имеет право выполнять ТО?', 'Специализированные организации с аттестованными сотрудниками, имеющие регистрацию в жилищной инспекции и Договор об оказании услуг по аварийно-диспетческому обслуживанию'],
        ['Что такое ВДГО?', 'Внутридомовое газовое оборудование.'],
        ['Что входит в ВДГО?','В домовладениях - находящиеся в пределах земельного участка, на котором расположено домовладение, газопроводы, проложенные от источника газа (при использовании сжиженных углеводоровных газов)' +
        'или места присоединения указанных газопроводов к сети газораспределения до бытового газоиспользующего оборудования, резервуарные и (или) групповые баллонные установки сжиженных углеводородных газов,' +
        ', предназначенные для подачи газа в одно домвладение, индивидуальные баллонные установки сжиженных углеводородных газов, бытовое газоиспользующее оборудование, технические устройства на газопроводах, в том числе ' +
        'запорная регулирующая и предохранительная арматура, системы контроля загазованности помещений и приборы учёта газа.'],
        ['Какие работы выполняются при ТО?', 'Минимальный перечень выполняемых работ по техническому обслуживанию и ремонту газового оборудования следующий: 1) визуальная проверка целостности и соответствия нормативным требованиям' +
        'газового оборудования, 2) визуальная проверка наличия свободного доступа к газовому оборудованию, 3) визуальная проверка состояния окраски и креплений газопровода, 4) визуальная проверка наличия и целостности футляров в местах прокладки' +
        'через наружные и внутренние конструкции многоквартирных домов и домовладений, 5) проверка герметичности соединений и отключающих устройств, 6) проверка работоспособности и смазка отключающих устройств, 7) разборка и смазка кранов,' +
        ' 8) проверка работоспособности устройств, позволяющих автоматически отключить подачу газа при отклонении контролируемых параметров за допустимые пределы, её наладка и регулировка, 9) регулировка процесса сжигания газа на ' +
        'всех режимах работы, очистка горелок от загрязнений, 10) проверка давления газа перед газоиспользующим оборудованием при всех работающих горелках и после прекращения подачи газа, 11) замена баллонов для сжиженных углеводорных газов' +
        ', 12) проверка наличия тяги в дымовых и вентиляционных каналах, состояния соединительных труб с дымовым каналом, 13) инструктаж потребителей газа по безопасному использованию газа при удоволетворении коммунально-бытовых нужд. '],
        ['Когда могут приостановить подачу газа?', 'В случае поступления исполнителю инфомации о наличии угрозы возникновения аварии, утечек газа или несчастного случая, в том числе получения такой информации в ходе выполнения работ' +
        'по техническому обслуживанию и ремонту газового оборудования, исполнитель обязан незамедлительно осуществить приостановление подачи газа без предварительного уведомления об этом заказчика. Исполнитель вправе приостановить' +
        'подачу газа с предварительным письменным уведомлением заказчика в следующих случаях: а) отказ заказчика 2 и более раза в допуске специализированной организации для проведения работ по техническому обслуживанию газового оборудования,' +
        'б) отсутствие договора о техническом обслуживании и ремонте газового оборудования, в) истечение у газового оборудования нормативного срока службы, установленного изготовителем, и отсутствие положительного заключения' +
        'по результатам технического диагностирования указанного оборудования, а в случае продления этого срока по результатам диагностирования - истечение продлённого срока службы указанного оборудования'],
        ['Кто обеспечивает аварийно-диспетчерское обслуживание?', 'АДО осуществляется газораспределительной организацией в соответствии с законодательством РФ'],
        ['Кто отвечает за вентканалы и дымоход в многоквартирных домах?', 'Лица, ответственные за содержание общего имущества в многокв. доме, либо организация, с которой заключён договор договор об их проверке/очистке/ремонте'],
        ['Кто отвечает за вентканалы и дымоход в домовладении?', 'Собственник домовладения, либо организация, с которой заключён договор договор об их проверке/очистке/ремонте']])

      const filteredQuestions = computed( () => {
        if (!!filter.value.question) {
          return questions.value.filter((item) => {
          return (
                item[0].toLowerCase().includes(filter.value.question.toLowerCase())
            )
          }) } else {
          return questions.value
        }
      })

      return {
        filter, questions, filteredQuestions
      }
    }
  }

</script>

<style scoped>
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .questions {
    display: flex;
    flex-direction: column;
    max-width: 1600px;
  }

  .question {
    background: white;
    margin: 10px;
    border-radius: 30px;
    width: 1000px;
  }

  p {
    font-size: 1.5em;
    margin-left: 20px;
    margin-right: 20px;
  }

  h1 {
    margin-left: 20px;
    margin-right: 20px;
  }

  @media (max-width: 1200px) {
    .question {
      width: 800px;
    }
  }
  @media (max-width: 1000px) {
    .question {
      width: 600px;
    }
  }
  @media (max-width: 700px) {
    .question {
      width: 300px;
    }

    h1, p {
      font-size: 1em;
    }
  }
</style>